module.exports = __webpack_public_path__ + "static/media/akhil_harikumar.5140c4ee.png";